import dotenv from 'dotenv';
dotenv.config();

export default class ConfigProvider {
  public static get CONFIG(): any {
    return {
      endpointAPI: '$VUE_APP_ROOT_API',
      tokenName: '$VUE_APP_TOKEN_NAME',
    };
  }

  public static value(name: any) {
    if (!(name in this.CONFIG)) {
      return;
    }

    const value = this.CONFIG[name];

    if (!value) {
      return;
    }

    if (value.startsWith('$VUE_APP_')) {
      const envName = value.substr(1);
      const envValue = process.env[envName];
      if (envValue) {
        return envValue;
      } else {
        return
      }
    } else {
      return value;
    }
  }
}